/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_FullInputs */

const en_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const ar_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#كامل`)
};

const bn_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const de_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const es_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const fr_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const pt_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const zh_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const tr_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const ru_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

const pl_svtag_full = /** @type {(inputs: Svtag_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#FULL`)
};

/**
* | output |
* | --- |
* | "#FULL" |
*
* @param {Svtag_FullInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_full = /** @type {((inputs?: Svtag_FullInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_FullInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_full(inputs)
	if (locale === "bn") return bn_svtag_full(inputs)
	if (locale === "de") return de_svtag_full(inputs)
	if (locale === "es") return es_svtag_full(inputs)
	if (locale === "fr") return fr_svtag_full(inputs)
	if (locale === "pt") return pt_svtag_full(inputs)
	if (locale === "zh") return zh_svtag_full(inputs)
	if (locale === "tr") return tr_svtag_full(inputs)
	if (locale === "ru") return ru_svtag_full(inputs)
	if (locale === "pl") return pl_svtag_full(inputs)
	return en_svtag_full(inputs)
});